import _styled, { default as _styled2 } from "styled-components";
import type { SanityPageBuilderPointCloudSection, SanityPageBuilderSection } from "@ouster/shared";
import { PointCloudBlockView } from "~/features/blocks/inventory/point-cloud";
import { PointCloudBottomMediaView } from "~/features/blocks/inventory/point-cloud/point-cloud-bottom-media";
import { PointCloudTopMediaView } from "~/features/blocks/inventory/point-cloud/point-cloud-top-media";
import { toCraftMedia } from "~/features/sanity/media";
import { Media } from "~/features/ui/media";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderPointCloudSection;
  };
};
function renderTopMedia(media: ReturnType<typeof toCraftMedia>) {
  if (!media) {
    return undefined;
  }
  return <PointCloudTopMediaView media={<Media {...media} imageProps={{
    fit: "cover"
  }} inlineVideoProps={{
    fit: "cover"
  }} externalVideoProps={{
    fit: "cover"
  }} />} />;
}
function renderBottomMedia(media: ReturnType<typeof toCraftMedia>, scale?: string) {
  if (!media) {
    return undefined;
  }
  return <PointCloudBottomMediaView media={<Media {...media} imageProps={{
    ratio: "1/1"
  }} inlineVideoProps={{
    ratio: "1/1"
  }} externalVideoProps={{
    ratio: "1/1"
  }}>
          {scale && <_StyledDiv>
              <_StyledSpan>{scale}</_StyledSpan>
            </_StyledDiv>}
        </Media>} />;
}
export function SanityPointCloudSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const mediaData = toCraftMedia(sectionContent.media);
  return <PointCloudBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} bottomMedia={renderBottomMedia(toCraftMedia(sectionContent.bottomMedia?.media), sectionContent.bottomMedia?.scale)} hasTopDivider={sectionSettings?.hasTopDivider ?? true} maxZoom={sectionContent.maxZoom} media={(overlay, ratio) => <Media {...mediaData} showCaption imageProps={{
    ratio,
    rounded: false
  }} inlineVideoProps={{
    ratio,
    rounded: false
  }} externalVideoProps={{
    ratio,
    rounded: false
  }}>
          {overlay}
        </Media>} minZoom={sectionContent.minZoom} mode={sectionSettings?.mode || "light"} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} theme={sectionSettings?.theme || "white"} title={sectionContent.headline} topMedia={renderTopMedia(toCraftMedia(sectionContent.topMedia?.media))} />;
}
var _StyledDiv = _styled("div").withConfig({
  componentId: "sc-sf-abipyp-0"
})({
  "position": "absolute",
  "bottom": "0",
  "left": "0",
  "display": "flex",
  "height": "3.2rem",
  "alignItems": "center",
  "justifyContent": "center",
  "borderRightWidth": "1px",
  "borderTopWidth": "1px",
  "borderColor": "currentColor",
  "padding": "0.8rem"
});
var _StyledSpan = /*#__PURE__*/_styled2("span").withConfig({
  displayName: "point-cloud___StyledSpan",
  componentId: "sc-vpjbe0-0"
})({
  "fontFamily": "Aeonik, ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif",
  "fontSize": "1.4rem",
  "lineHeight": "1.1",
  "letterSpacing": "0.028000000000000004rem",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "1.6rem",
    "lineHeight": "1.1",
    "letterSpacing": "0.032rem",
    "fontWeight": "400"
  }
});